import type * as React from 'react';
import { post } from '@Domain/Api';
import type { AiProviderPayload } from '@Application/Ai/AiConfiguration/Providers/Actions/aiProvidersFetched';
import aiProviderCreated, {
	type AiProviderCreatedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderCreated';
import aiProviderCreationFailed, {
	type AiProviderCreationFailedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderCreationFailed';
import type CreateAiProvider from '@Application/Ai/AiConfiguration/Providers/Commands/CreateAiProvider';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiProviderCreatedAction | AiProviderCreationFailedAction;

export default (command: CreateAiProvider) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<AiProviderPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-providers`,
				command.toJSON(),
			);

			const action = aiProviderCreated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiProviderCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
